import { Mui } from "@osu/react-ui";
import Paper from "../../Dashboard/components/Paper";

function Card({ title, children, Icon }) {
  const hasHeading = !!title
  return (
    <Paper component={hasHeading ? "section" : "div"}>
      {hasHeading && <Mui.Typography sx={{ pb: 1, display: 'flex', alignItems: 'center' }} component="h2" variant="h6">
       {Icon &&  <Icon sx={{ mr: 1 }} fontSize="inherit" />}
        {title}
      </Mui.Typography>}
      <Mui.Divider sx={{ mb: 1 }} />
      {children}
    </Paper>
  );
}

export default Card;
